import { jsx as _jsx } from "react/jsx-runtime";
import { Badge, IconButton, Tooltip } from "@mui/material";
import { PronunciationIcon } from "../../../Icons";
export const PronunciationSection = (props) => {
    const onClick = (e) => {
        props.onEditorBlur();
        props.onPronunciationClick(e);
    };
    return (_jsx(Badge, { variant: "dot", color: "info", anchorOrigin: {
            horizontal: "right",
            vertical: "bottom"
        }, overlap: "circular", invisible: props.badgeInvisible, children: _jsx(Tooltip, { title: props.tooltipTitle, children: _jsx(IconButton, { onClick: onClick, "data-tracking-id": "tracking-id-vo-ph-pronunciation-top", children: _jsx(PronunciationIcon, {}) }) }) }));
};
//# sourceMappingURL=PronunciationSection.js.map